import styled from 'styled-components/macro';

export const Container = styled.div`
  width: 100%;
`;

export const CustomerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CustomerAction = styled.div`
  opacity: 0;
  transition: opacity 0.2s linear;
  @media (pointer: coarse) {
    opacity: 1;
  }
  ${CustomerContainer}:hover & {
    opacity: 1;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
`;

export const CustomerList = styled.div`
  position: absolute;
  width: max-content;
  min-width: 100%;
  max-width: 150%;
  padding: 0.5rem;
  margin-left: -0.5rem;
  margin-top: 0.5rem;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-grey-lightest);
  border-radius: var(--border-radius-xs);
  background-color: var(--color-modal);

  z-index: 160;
`;

export const CustomerWrapper = styled.div`
  padding: 0.5rem;
  border: 1px solid transparent;
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: var(--color-input-hover);
  }

  &:focus {
    outline: none;
    border-color: var(--color-input-focus);
    border-radius: var(--border-radius-xs);
  }
`;

export const NewCustomer = styled.div`
  color: var(--color-primary-dark);
`;

export const SourcedCustomer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  min-width: 0;

  > img {
    height: 1.25rem;
    width: 1.25rem;
    margin-left: 0.5rem;
  }
`;

export const ColorAndNameContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  a {
    color: currentColor;
  }
`;

// TODO: Copied from project-list-style, should probably be an atom
export const ColorCode = styled.div`
  width: 0.75rem;
  height: 0.75rem;
  margin-right: 0.5em;
  display: inline-block;
  border-radius: var(--border-radius-full);
  background-color: ${props => props.backgroundColor};
`;
